import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Divider, Grid } from "@mui/material";
import type { Dispatch } from "react";
import { useTranslation } from "react-i18next";
import { CdcFilter } from "./CdcFilter";
import { ColorStatusFilter } from "./ColorStatusFilter";
import { CustomerFilter } from "./CustomerFilter";
import { OemFilter } from "./OemFilter";
import { SapNumberFilter } from "./SapNumberFilter";
import { SubstanceListFilter } from "./SubstanceListFilter";

export interface GeneralFilterProps {
  colorStatusValue?: Array<AutocompleteData>;
  onColorStatusValueChange: Dispatch<Array<AutocompleteData>>;
  substanceListValue?: Array<AutocompleteData>;
  onSubstanceListValueChange: Dispatch<Array<AutocompleteData>>;
  cdcs?: Array<AutocompleteData>;
  onCdcsChange: Dispatch<Array<AutocompleteData>>;
  oemName?: Array<AutocompleteData>;
  oemNameChange: Dispatch<Array<AutocompleteData>>;
  customerName?: Array<AutocompleteData>;
  customerNameChange: Dispatch<Array<AutocompleteData>>;
  setSapNumber: Dispatch<Array<AutocompleteData>>;
  sapNumber?: Array<AutocompleteData>;
  columns?: number;
}

export const GeneralFilter = ({
  colorStatusValue,
  onColorStatusValueChange,
  substanceListValue,
  onSubstanceListValueChange,
  cdcs,
  onCdcsChange,
  oemName,
  oemNameChange,
  customerName,
  customerNameChange,
  setSapNumber,
  sapNumber,
  columns = 12,
}: GeneralFilterProps) => {
  const { t } = useTranslation();

  return (
    <Grid mt={-2} mb={2} container spacing={2} columns={columns}>
      <Grid size={{ xs: 12, md: 6, xl: 3 }}>
        <ColorStatusFilter
          t={t}
          value={colorStatusValue}
          onChange={onColorStatusValueChange}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, xl: 3 }}>
        <SubstanceListFilter
          t={t}
          value={substanceListValue}
          onChange={onSubstanceListValueChange}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, xl: 3 }}>
        <CdcFilter t={t} value={cdcs} onChange={onCdcsChange} />
      </Grid>
      <Grid size={12}>
        <Divider light />
      </Grid>
      <Grid size={{ xs: 12, md: 6, xl: 3 }}>
        <OemFilter t={t} value={oemName} onChange={oemNameChange} />
      </Grid>
      <Grid size={{ xs: 12, md: 6, xl: 3 }}>
        <CustomerFilter
          t={t}
          value={customerName}
          onChange={customerNameChange}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6, xl: 3 }}>
        <SapNumberFilter t={t} value={sapNumber} onChange={setSapNumber} />
      </Grid>
    </Grid>
  );
};
